import _map from 'lodash.map';

import createHistory from 'history/createBrowserHistory';

let h;
const historyService = {};

historyService.parseParams2Object = params_string => {
  const params = {};
  params_string
    .replace(/\?/g, '')
    .split('&')
    .map(v => {
      params[decodeURIComponent(v.split('=')[0])] = decodeURIComponent(
        v.split('=')[1]
      );
    });
  return params;
};

historyService.parseObject2Params = params_object =>
  _map(params_object, (v, k) => {
    return encodeURIComponent(k) + '=' + encodeURIComponent(v);
  }).join('&');

historyService.listener = callback => {
  return h.listen((location, action) => {
    const params = historyService.parseParams2Object(location.search);
    callback(location, params, action);
  });
};

historyService.params = () =>
  historyService.parseParams2Object(h.location.search);

historyService.createComponentHistory = () => {
  h = createHistory();
};

const history = () => h;

export { history, historyService };



// WEBPACK FOOTER //
// ./app/javascript/services/history.js